import React from 'react'
import ScrollAnimatedItem from '../utils/ScrollAnimatedItem'

export const ToolBarMenu = [
    { href: "#about", text: "About", section: "about" },
    { href: "#projects", text: "Work", section: "work" },
    { href: "#contact", text: "Contact", section: "contact" }
];

export const scrollToSection = (event, sectionId) => {
    event.preventDefault();
    const element = document.getElementById(sectionId);
    const yOffset = -0.5;
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
};

export const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: (i = 1) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.15,
            duration: 0.7,
            ease: 'easeOut'
        }
    })
};

export const Skill = ({ title, content }) => (
    <div className='flex flex-col gap-1 md:flex-row lg:flex-col md:place-items-center lg:place-items-start'>
        <h2 className="text-lg lg:text-lg font-semibold dark:text-white">{title} {' : \u00A0'}</h2>
        <p className="text-base lg:text-[17px] text-gray-600 dark:text-slate-300">{content}</p>
    </div>
);

export const Experience = ({ company, role, logo, description, certificateLink, index }) => (
    <ScrollAnimatedItem
        custom={index}
        className="border border-slate-300 dark:border-dotted border-opacity-80 dark:border-slate-700 rounded-lg hover:shadow-sm dark:shadow-slate-800 transition-colors"
        triggerOnce={true}
    >
        <div className="p-6 flex flex-col sm:flex-row gap-4 items-start">
            <img
                src={logo}
                alt={company}
                className="w-20 h-20 object-contain rounded-md"
                loading="lazy"
            />
            <div className="flex flex-col gap-3">
                {/* Company + Role */}
                <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center">
                    <p className="font-bold text-lg text-black dark:text-white">{company}</p>
                    <span className="hidden sm:inline font-bold text-lg text-black dark:text-white">|</span>
                    <p className="font-semibold text-base text-gray-700 dark:text-slate-200">{role}</p>
                </div>

                {/* Description */}
                <p className="text-gray-800 dark:text-slate-300 leading-relaxed">
                    {description}
                </p>

                {/* Certification Button */}
                <a
                    href={certificateLink}
                    rel="noreferrer"
                    target="_blank"
                    className="inline-flex items-center justify-center text-sm font-semibold bg-black hover:bg-gray-800 text-white dark:bg-slate-100 dark:text-black dark:hover:bg-gray-300 h-9 rounded-md px-4 w-fit"
                >
                    Certification
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 ml-1"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                        <polyline points="15 3 21 3 21 9" />
                        <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                </a>
            </div>
        </div>
    </ScrollAnimatedItem>
);

export const SkillsInfo = [
  {
    title: "Languages",
    content: "C++, Java, JavaScript, Python, SQL, HTML/CSS",
  },
  {
    title: "Frameworks",
    content:
      "React.js, Spring Boot, Spring MVC, Node.js, Express.js, TanStack Query, REST API, Tailwind CSS, BootStrap",
  },
  {
    title: "Cloud Platforms",
    content: "Amazon Web Services (AWS), Google Cloud Platform (GCP)",
  },
  { title: "Databases", content: "MySQL, MongoDB, PostgreSQL" },
  { title: "Tools", content: "Git, GitHub, Docker, Postman, Vercel" },
];

export const ProjectsInfo = [
  {
    title: "Match IQ - Smart Hiring Platform",
    description:
      "AI-powered resume-job matching with rankings and fit insights",
    image: "images/smart-hiring-platform.png",
    tech: [
      "ReactJS",
      "Spring Boot",
      "LLaMA",
      "TanStack",
      "PostgreSQL",
      "Tailwind CSS",
    ],
    live: "https://github.com/venkataRahulBabu/smart-hire-react",
    github: "https://github.com/venkataRahulBabu/smart-hire-react",
  },
  {
    title: "APSRTC Duty Portal",
    description: "A Duty assigning portal for APSRTC Employees.",
    image: "images/apsrtc.png",
    tech: ["ReactJS", "Spring Boot", "TanStack", "PostgreSQL", "Tailwind CSS"],
    live: "https://apsrtc-duty-portal.vercel.app",
    github: "https://github.com/venkataRahulbabu/APSRTC-Duty-Portal",
  },
  {
    title: "Aero Connect",
    description:
      "Finds the fastest and cheapest flights using Dijkstra's Algorithm",
    image: "images/aero-connect.png",
    tech: ["NodeJS", "JavaScript", "MongoDB", "Tailwind CSS"],
    live: "https://aero-connect.vercel.app",
    github: "https://github.com/venkataRahulbabu/Air-Connect",
  },
  {
    title: "Chat-PDF",
    description: "Chat with PDF using an Intelligent AI Assistant.",
    image: "images/Chat-PDF.png",
    tech: ["Python", "Streamlit", "VectorDB", "Gemini AI"],
    live: "https://chat-pdf-python.onrender.com",
    github: "https://github.com/venkataRahulbabu/Chat-PDF-python",
  },
  {
    title: "Vydhya - Medicure",
    description: "A simple way to book an appointment for Hospital.",
    image: "images/vydhya-medicure.png",
    tech: ["JavaScript", "Django", "Bootstrap", "MySQL"],
    live: "https://github.com/venkataRahulbabu/Vydhya-Medicure",
    github: "https://github.com/venkataRahulbabu/Vydhya-Medicure",
  },
];
